import React, { forwardRef } from 'react'
import { createUseStyles } from 'react-jss'
import theme from '../../style/theme'
import { span } from '../../style/span'
import { vw } from '../../style/vw'
import ScrollIndicator from './ScrollIndicator'

const Sidebar = forwardRef(({ className }, ref) => {
  const classes = useStyles()
  // const socialLinks = useSelector(getSocialLinks)
  return (
    <aside className={classes.aside} ref={ref}>
      <div className={classes.scrollIndicatorContainer}>
        <ScrollIndicator />
      </div>
    </aside>
  )
})

const useStyles = createUseStyles({
  aside: {
    color: theme.colors.white,
    mixBlendMode: 'difference',
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: span(1),
    zIndex: theme.zIndex.sidebar,
    flexDirection: 'column',
    pointerEvents: 'none',
    [theme.breakpoints.up('md')]: {
      width: span(1, 'md'),
      right: span(1, 'md')
    }
  },
  scrollIndicatorContainer: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  socialLinks: {
    pointerEvents: 'all',
    flexGrow: 0,
    display: 'none',
    position: 'absolute',
    bottom: 0,
    right: 0,
    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  },
  socialLink: {
    display: 'block',
    width: vw(22),
    margin: [0, 0, span(1), 'auto'],
    [theme.breakpoints.up('md')]: {
      margin: [0, 0, span(1, 'md'), 'auto'],
      width: vw(22, 'desktop')
    }
  }
}, { name: 'Sidebar' })

export default Sidebar
